import { PermissionCreate } from './PermissionCreate'
import { PermissionEdit } from './PermissionEdit'
import { PermissionList } from './PermissionList'
import { PermissionShow } from './PermissionShow'

export { PermissionCreate, PermissionEdit, PermissionList, PermissionShow }
